export const TimeIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.27423 8.44676C3.13207 3.85863 7.54734 0.834337 12.1356 1.69188C16.7237 2.54949 19.7486 6.9641 18.8914 11.5522C18.0338 16.1405 13.6184 19.1656 9.03009 18.3081C4.44176 17.4505 1.41674 13.0351 2.27423 8.44676ZM11.8299 3.32957C8.14657 2.6411 4.60182 5.06929 3.91291 8.75243C3.22442 12.436 5.65228 15.9818 9.33576 16.6704C13.0192 17.3589 16.5641 14.93 17.2528 11.2466C17.941 7.56323 15.5132 4.01823 11.8299 3.32957ZM11.4158 10.0093L15.0613 12.355L14.6111 13.0561L14.16 13.7563L10.1317 11.1665L9.74982 10.9204V5.42918H11.4158V10.0093Z"
    />
  </svg>
);
